const FUNCTIONS_URL = 'https://us-central1-lctf-projects.cloudfunctions.net';

async function post<T>(name: string, body: Record<string, unknown>): Promise<T> {
  const res = await fetch(`${FUNCTIONS_URL}/${name}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    throw new Error(json.error || `Request failed (${res.status})`);
  }
  return json as T;
}

export type PublicOfferPolicy = {
  id: string;
  title: string;
  policyNumber: string;
  currentVersion: string;
  summary: string;
  body: string;
  bodyFormat: 'html' | 'plain';
  sortOrder: number;
};

export type PublicJobOfferPayload = Record<string, unknown> & {
  id?: string;
  slug?: string;
  status?: string;
  fields?: Record<string, unknown>;
  clauses?: Record<string, unknown>;
  sections?: unknown[];
  agreementSections?: unknown[];
  ceoSignature?: unknown;
  employeeSignature?: unknown;
  agreementCeoSignature?: unknown;
  agreementEmployeeSignature?: unknown;
  policyAcks?: Array<Record<string, unknown>>;
  startDateConfirmedAt?: unknown;
  sentAt?: unknown;
  contractSentAt?: unknown;
  offerSignedAt?: unknown;
  signedAt?: unknown;
  signedPdfUrl?: string | null;
};

export async function fetchPublicJobOffer(slug: string) {
  return post<{ success: true; offer: PublicJobOfferPayload; policies: PublicOfferPolicy[] }>(
    'getPublicJobOffer',
    { slug },
  );
}

export async function signPublicJobOffer(input: {
  slug: string;
  signedBy: string;
  dataUrl: string;
  document?: 'offer' | 'agreement';
}) {
  return post<{ success: true }>('signJobOfferLetter', input);
}

export async function ackPublicJobOfferPolicy(input: { slug: string; policyId: string }) {
  return post<{ success: true }>('ackJobOfferPolicy', input);
}

export async function confirmPublicJobOfferStart(slug: string) {
  return post<{ success: true }>('confirmJobOfferStart', { slug });
}
